import React from 'react';
import Diretory from '../../components/directory/directory.component';
import { HomePageContainer } from './homepage.styles';

const HomePage = () => {

    return (
        <HomePageContainer>
            <Diretory />
        </HomePageContainer>
    )
    
       
    



}


export default HomePage;